// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__Yfkgt","main":"SecTwo_main__4vDoF","text":"SecTwo_text__TKgJE","types":"SecTwo_types__beG9X","type":"SecTwo_type__8k3B6","arrow":"SecTwo_arrow__XLLL7"};